import React from "react";
import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";

const MapReusable = compose(
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyBQwWgamVVVvBLQ4qoAlyRTD4kKaC6t35o&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: (
      <div className="map-section-one" style={{ height: `100%` }} />
    ),
    containerElement: <div className="map-section" />,
    mapElement: <div className="map-section-two" style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props) => (
  <GoogleMap defaultZoom={8} defaultCenter={{ lat: -34.397, lng: 150.644 }}>
    {props.isMarkerShown && (
      <Marker position={{ lat: -34.397, lng: 150.644 }} />
    )}
  </GoogleMap>
));

export default MapReusable;
